import { createContext } from 'react';

const impersonationContext = createContext();

export default impersonationContext;
